import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasDrainage = createSelector(selectJsonQuery, jsonQuery => getTermValue('has_drainage')(jsonQuery));
